import $ from 'jquery';
import RichMenu from '../libs/RichMenu';
import app from '../app';

export default {

    modalOpen: false,

    init() {
        $('[data-modal]').each((index, element) => {

            $(element).on('click', event => {
                event.preventDefault();
                this.showModal(element.dataset.modal);
            });
        });
    },

    showModal(idModal) {
        $('html').addClass('no-scroll');

        let opacity = 0.4;

        if (idModal === '#social-wall-detail') {
            opacity = 0.8;
        }

        if (idModal !== '#search-panel') {
            RichMenu.showBgOverlay('modal', 300, opacity);
        }

        if (idModal === '#social-wall-detail' || idModal === '#search-panel' || idModal === '#modal-call-to' || idModal === '#modal-geneve-alert') {
            $(idModal).css('display', 'flex');
        } else {
            $(idModal).css('display', 'block');
        }

        setTimeout(function () {
            $(idModal).addClass('show');

            if (idModal === '#search-panel') {
                $('#search-panel input').focus();
            }
        }, 100);

        this.initEvents(idModal);

        this.modalOpen = true;

    },

    initEvents(idModal) {
        // $(document).on('click', `${idModal} .close-button`, () => this.hideModal(idModal));

        $(`${idModal} .close-button`).on('click', () => this.hideModal(idModal));

        $('#bg-overlay').on('click', () => this.hideModal(idModal));

        $(window).on('keyup', event => {
            if (event.keyCode === 27) { // Escape key
                this.hideModal(idModal);
            }
        });

    },

    hideModal(idModal) {
        if (idModal !== '#search-panel') {
            RichMenu.hideBgOverlay('modal');
        }

        $(idModal).removeClass('show');
        setTimeout(function () {
            $('html').removeClass('no-scroll');
        }, 300);
        $(idModal + ' .close-button').unbind('click');
        $('#bg-overlay').unbind('click');

        setTimeout(function () {
            $(idModal).removeAttr('style');
        }, 350);

        this.modalOpen = false;
    },

};



// WEBPACK FOOTER //
// ./assets/js/libs/Modal.js